import 'slick-carousel'
import SLIDER from '../class/slider'
import GET_ARTICLES from '../plugins/getArticles'

const [ w, d, mq ] = [ window, document, window.matchMedia( "(max-width: 900px)" ) ]

const mainSlider = new SLIDER({
  obj: '[data-plugin="slider"]',
  animationDuration: 3600,
  slickOpt: {
    autoplay: false,
    autoplaySpeed: 2600,
    speed: 1000,
    arrows: true,
    prevArrow: '<button type="button" class="slick-prev"><svg class="icon" width="12" height="22"><use href="/asset/svg/sprite.symbol.svg#slider_arrow_left"></use></svg></button>',
    nextArrow: '<button type="button" class="slick-next"><svg class="icon" width="12" height="22"><use href="/asset/svg/sprite.symbol.svg#slider_arrow_right"></use></svg></button>',
    dots: true,
    variableWidth: true,
    centerMode: true,
    centerPadding: '5%',
    slideToShow: 3,
    infinite: true,
    cssEase: 'ease-in-out',
    waitForAnimate: false,
    focusOnSelect: true,
    pauseOnHover: false,
    pauseOnFocus: false,
    responsive: [{
      breakpoint: 900,
      settings: {
        centerMode: false
      }
    }]
  }
});


const achievementSlider = new SLIDER({
  obj:'.block-achievement__list',
  slickOpt: {
    slidesToShow: 5,
    slidesToScroll: 1,
    infinite: true,
    variableWidth: true,
    centerMode: true,
    centerPadding: '10px',
    arrows: false,
    autoplay: true,
    autoplaySpeed: 1000,
    speed: 2500,
    easing: 'easeInOutExpo',
    useCSS: true
  }
});

const tagList = tags => {
  const $tags = $('<div class="tags"></div>');

  tags.forEach( tag => {
    const $tag = $('<span class="tag"/>');
    $tag.text( '#' + tag ).appendTo( $tags );
  });
  return $tags[0].outerHTML;
};

const init = () => {

  w.load['mainvisual'].then( () => {
    mainSlider.init(), mainSlider.start();
  });

  // ticker
  $.when( w.load['block-ticker'] ).then(() => {
    let makeItem = item => $(`
      <a href="${item.href}" class="link">
        <div class="inner">
          <span class="cate">[${item.category.name}]</span>
          <span class="subject">${item.title.str_truncate(30)}</span>
        </div>
      </a>
    `)[0]
    GET_ARTICLES( '.block-ticker__article[data-plugin="getArticles"]', { makeItem })
  })

  // property
  $.when( w.load['block-newproperty'] ).then( () => {
    let makeItem = item => {
      return $(`
      <a class="block-property-item" href="${item.href}">
        <figure class="block-property-item__img">
          <div class="block-property-item__img-cover" style="background-image:url(${item.thumb})"><img src="${item.thumb}" alt="${item.title}" width="220"></div>
        </figure>
        <div class="block-property-item__body">
          <span class="subject ${item.is_new ? 'is-new': ''}">${item.title.str_truncate(24)}</span>
          <span class="desc">${item.desc.str_truncate(24)}</span>
          ${item.keywords ? tagList(item.keywords) : ''}
        </div>
        <!-- /.block-property-item__body -->
      </a>
    `)[0]
    }
    GET_ARTICLES('.block-property-content__list[data-plugin="getArticles"]', { makeItem }).then( (sale,rent) => {
      if ( sale.length == 0 ) $('.block-property-content.is-sale').remove();
      if ( rent.length == 0 ) $('.block-property-content.is-rent').remove();
      if ( sale.length == 0 && rent.length == 0 ) $('.block-property').remove();
    });
  });

  // achievement
  $.when( w.load['block-achievement'] ).then( () => {
    let makeItem = item => $(`
    <li class="block-achievement__item">
      <a href="${item.href}" class="block-achievement__link">
        <figure class="block-achievement__img">
          <div class="block-achievement__img-cover" style="background-image:url(${item.thumb})"><img src="${item.thumb}" alt="${item.title}" width="220" decoding="async"></div>
        </figure>
        <span class="subject">${item.title.str_truncate(18)}</span>
      </a>
    </li>
    `)[0]
    GET_ARTICLES('.block-achievement__list[data-plugin="getArticles"]', { makeItem }).then( () => {
      const $achievementItem = $('.block-achievement__item')

      $achievementItem.each( (i, v) => {
        $(v).clone().appendTo('.block-achievement__list')
      });

      if( !mq.matches ) {
        achievementSlider.init();
      }
    })
  });

  // news
  $.when( w.load['block-news'] ).then( () => {
    let makeItem = item => $(`
      <a class="block-news-item" href="${item.href}">
        <div class="date-cate">
          <span class="date">${item.date}</span>
          <span class="cate">[${item.category.name}]</span>
          ${item.is_new ? '<span class="is-new">NEW</span>': ''}
        </div>
        <span class="subject">${item.title}</span>
      </a>
    `)[0]
    GET_ARTICLES('.block-news__list[data-plugin="getArticles"]', { makeItem })
  });


}

export default function HOME() {
  $( init )
}